module.exports = __webpack_public_path__ + "media/images/visa-bcc11735deeedd978bfd063ef14380af.svg";